import { createFileRoute } from "@tanstack/react-router";

import { TermsPage } from "@/components/Pages/Terms";

export const Route = createFileRoute("/terms")({
  component: TermsPage,
});
